import { GlobalState } from '../../../types.global';
import { selectFeatureFlags, selectIsUserRegular } from '../../../store/selectors';
import { timeInMs } from '../../../../shared';
import { VeveBanner } from './types';

export const createSelectShouldFetch = (now: number) => (state: GlobalState): boolean => {
  if (!selectIsUserRegular(state)) return false;
  if (state.banner.disabledUntil) return false;

  const { BANNER_ON } = selectFeatureFlags(state);
  if (!BANNER_ON) return false;

  const { savedAt } = state.banner;
  return !savedAt || savedAt < now - timeInMs.minute;
}

/*
const fakeBanner = {
  rank: '1',
  brand: 'CocaCola',
  category: 'Category 1', /// "Category 1",
  title: 'Title 1', /// "Title 1",
  desc: 'Desc1', /// "Desc1",
  rurl: 'https://ww55.affinity.net/sssdomweb?enk=ec51ae22b746861f1753b77415e3180a933de9bf12b4b54c7c887129d9261a8a3f889dd4d208b1c60c8b6a6f8966dca776ca6e70a64c85852c3ff26add3689156c76b6718', /// "https://ww55.affinity.net/sssdomweb?enk=ec51ae22b746861f1753b77415e3180a933de9bf12b4b54c7c887129d9261a8a3f889dd4d208b1c60c8b6a6f8966dca776ca6e70a64c85852c3ff26add3689156c76b6718",
  iurl: 'https://static-02.veve.com/36x36/ddcbb0c17cccf6a1.png',
  burl: 'https://static-02.veve.com/banner/83de649a02f345f9.png',
  favico: 'https://static-02.veve.com/36x36/ddcbb0c17cccf6a1.png',
  adid: 'adid1',
  impurl: 'https://imptrk.siteplug.com/impTrk.php?enk1=0466a8d5aee5ffbe3d3979bb1b569bda4a9e1570899fe7e1f0e0746aa4faf833a531784dca1416',
  durl: 'brand1.com',
};
 */

export const selectBanner = (state: GlobalState): VeveBanner | null => {
  const { BANNER_ON } = selectFeatureFlags(state);
  if (!BANNER_ON) return null;

  if (!selectIsUserRegular(state)) return null;
  if (state.banner.disabledUntil) return null;

  return state.banner?.list?.[0];
}
